import React from "react";

const MissingMatch = (props) => {
    return (
        <div>
            <h4>Product Match Missing</h4>
            <p>
                This indicates there is a match selected, <br />
                but no products are currently coming back from CES.
            </p>
            <div className="button-group -right">
                <button className="button" onClick={props.closeModal}>
                    Cancel
                </button>
                <button className="button -primary" onClick={props.deleteMatch}>
                    Remove Match
                </button>
            </div>
        </div>
    );
};

export default MissingMatch;
